<div class="container">
  <div class="header">
    <h4 class="title"><i class="mdi mdi-poll"></i> Report Settings</h4>
  </div>
  <progress-spinner *ngIf="isLoading"></progress-spinner>
  <div *ngIf="!isLoading">
    <div class="logo-container">
      <p class="company-logo">Company Logo</p>
      <div class="image-container">
        <img #divImage [src]="svgImage" alt="Company Logo" class="svg" />
      </div>
      <span class="bottom-label">150px</span>
      <span class="right-label">75px</span>
    </div>

    <div>
      <div class="drop-image-and-text">
        <div class="new-image">
          <i class="icon mdi mdi-close" (click)="removeLogo()" *ngIf="showClearButton"></i>
          <div class="dashed-border" *ngIf="!showClearButton" (click)="click($event)">
            <p class="drop-text">Drop new image here...</p>
            <input
              #file
              type="file"
              (change)="onFilesAdded($event)"
              accept="image/*"
              class="input-file"
            />
          </div>
          <div class="upload-logo" *ngIf="showClearButton">
            <img [src]="svgImagePreview" alt="Uploaded Image Preview" class="image-preview" />
          </div>
        </div>

        <div class="comment-box">
          <textarea
            class="comment"
            maxlength="200"
            placeholder="Please type message here..."
            [(ngModel)]="comment"
            (ngModelChange)="editMessage()"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="text-length">{{ 200 - comment?.length }} / 200</div>
    <div class="file-upload-section">
      <h3 class="file-upload-heading">Select File</h3>
      <div class="file-upload-container">
        <input class="file-upload-input" placeholder="Select file" [value]="fileName" readonly />
        <input #file type="file" (change)="onFilesAdded($event)" class="display-none" />
        <button class="input-btn btn-blue" *ngIf="showClearButton" (click)="removeLogo()">
          <i class="icon mdi mdi-close"></i>
        </button>
        <button class="input-btn btn-blue" (click)="file.click()" *ngIf="!showClearButton">
          <i class="icon mdi mdi-folder-open"></i>
        </button>
      </div>
    </div>
    <button
      mat-raised-button
      color="primary"
      class="save"
      (click)="saveReportSettings()"
      [disabled]="disableSaveButton"
    >
      Save
    </button>
  </div>
</div>
